import { FC } from 'react'
import { Spinner } from '@cloudscape-design/components'

const LoadingSpinner: FC = () => {
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh'
			}}
		>
			<Spinner size="large" />
		</div>
	)
}

export default LoadingSpinner
